<template>
  <div>
    <div class="feedback">
      <div class="feedback-conten">
        <form v-on:submit.prevent="submitForm">
          <div class="tip">
            <p class="w-6">{{$t('contact_63')}}</p>
            <p class="w-4 mobile_hide">
              <span class="tel">0800-898-000</span>
              <span>{{$t('contact_17')}}</span>
            </p>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label >{{$t('contact_5')}}</label>
              <div :class="{'error': isSubmit && !formData.gist}">
                <vue-select v-model="formData.gist" v-bind:list="gistList" ></vue-select>
                <p class="error-tip" v-if="isSubmit && !formData.gist">{{$t('contact_73')}}</p>
              </div>
            </div>
            <div class="col-md-6">
              <label ><em>*</em>{{$t('contact_6')}}</label>
              <div :class="{'error': isSubmit && !formData.revert}">
                <vue-select v-model="formData.revert" v-bind:list="revertList" ></vue-select>
                <p class="error-tip" v-if="isSubmit && !formData.revert">{{$t('contact_74')}}</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label >{{$t('contact_7')}}</label>
              <div :class="{'error': isSubmit && !formData.name}">
                <input type="text" v-model="formData.name" :placeholder="$t('contact_65')">
                <p class="error-tip" v-if="isSubmit && !formData.name">{{$t('contact_65')}}</p>
              </div>
            </div>
            <div class="col-md-6">
              <label >{{$t('contact_8')}}</label>
              <div :class="{'error': isSubmit && ((!formData.phone && formData.revert == '電話') || (formData.phone && !patternPhone(formData.phone))) }">
                <input type="text" v-model="formData.phone" :placeholder="$t('contact_66')">
                <p class="error-tip" v-if="isSubmit && !formData.phone && formData.revert == '電話'">{{$t('contact_66')}}</p>
                <p class="error-tip" v-if="isSubmit && formData.phone && !patternPhone(formData.phone)">{{$t('phoneError')}}</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label >{{$t('contact_11')}}</label>
              <div :class="{'error': isSubmit && (!formData.mail || (formData.mail && !patternEmail(formData.mail)))}">
                <input type="text" v-model="formData.mail" :placeholder="$t('contact_67')">
                <p class="error-tip" v-if="isSubmit && !formData.mail">{{$t('contact_67')}}</p>
                <p class="error-tip" v-if="isSubmit && formData.mail && !patternEmail(formData.mail)">{{$t('emailError')}}</p>
              </div>
            </div>
            <div class="col-md-6">
              <label >{{$t('contact_9')}}</label>
              <div :class="{'error': isSubmit && !formData.shopName}">
                <input type="text" v-model="formData.shopName" :placeholder="$t('contact_68')">
                <p class="error-tip" v-if="isSubmit && !formData.shopName">{{$t('contact_68')}}</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 textarea-box">
              <label for="">{{$t('contact_10')}}</label>
              <div :class="{'error': isSubmit && !formData.content}">
                <textarea name="" cols="100" rows="50" :placeholder="$t('contact_69')" v-model="formData.content"></textarea>
                <p class="error-tip" v-if="isSubmit && !formData.content">{{$t('contact_69')}}</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 div-122">
              <label >{{$t('contact_13')}}</label>
              <div class="upload"  @click.prevent="addImage()">
                <div :class="{'error': isSubmit && !photo}">
                  <em></em>
                  <span v-if="!photo">{{$t('contact_70')}}</span>
                  <span v-else>{{photo}}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6 div-122 div-123">
              <label >{{$t('contact_14')}}</label>
              <div class="graphic" v-if="graphicId"  :class="{'error': isSubmit && (!formData.verificationcode || isGraphicError)}">
                <input type="text" :placeholder="$t('contact_72')" v-model="formData.verificationcode" @change="()=>{this.isGraphicError = false}">
                <img :src="graphic + graphicId">
                <a class="reload-img"  @click="getGraphicId()"></a>
                <p class="error-tip" v-if="isGraphicError || (isSubmit && !formData.verificationcode)">{{$t('contact_72')}}</p>
              </div>
            </div>
          </div>
          <div class="agree">
            <label class="agree-box">
              <div  >
                <input type="checkbox" id="agree" name="agree" v-model="isAgree">
                <label for="agree"></label>
                <span><a href="#" @click.prevent="openClausePopUp()" class="agree-link" :class="{'gray':!isAgree}">{{$t('contact_15')}}</a></span>
              </div>
            </label>
            <div class="error" v-if="isSubmit && !isAgree">
              <p class="error-tip">{{$t('check')}}</p>
            </div>
          </div>
          <div class="agree-submit-btn">
            <button type="submit" class="agree-submit">{{$t('contact_16')}}</button>
          </div>
        </form>
      </div>
      <clausePopup v-if="isShowClause"  v-bind:text="text" v-on:closeChanged="closePopup"></clausePopup>
    </div>
    <div class="hot-line pc_hide">
      <p>
        <span class="tel"> <a href="tel:0800-898-000">0800-898-000</a></span>
        <span class="text">{{$t('contact_17')}}</span>
      </p>
    </div>

    <div class="popup-ok" v-if="isShowPopup">
      <div class="box">
        <h2>{{$t('feedbackTitle')}}</h2>
        <p>{{$t('feedbackTip')}}</p>
        <div class="btn-box">
          <button class="ok-submit" @click="()=>{this.isShowPopup=false;}">{{$t('ok')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import API from "../config/api";
import axios from "axios";
import ClausePopup from './clausePopup.vue'
import File from './File.vue'
import VueSelect from './vue-select'

export default {
  name: 'Feedback',
  data () {
    return {
      uploadFile:process.env.API_ROOT+ API.UploadFile,
      formData: {
        "gist": "",
        "revert": "",
        "name": "",
        "phone": "",
        "mail": "",
        "shopName": "",
        "content": "",
        "path": "",
        "verificationcode": ''
      },
      gistList: [
        {code: "服務相關", name: this.$i18n.t('contact_58')},
        {code: "產品相關", name: this.$i18n.t('contact_59')},
        {code: "衛生相關", name: this.$i18n.t('contact_60')},
        {code: "業務相關", name: this.$i18n.t('contact_61')},
        {code: "其他", name: this.$i18n.t('contact_62')},
      ],
      revertList: [
        {code: "電話", name: this.$i18n.t('store_9')},
        {code: "E-Mail", name: "E-Mail"},
      ],

      isAgree: false,
      isSubmit: false,
      graphic: process.env.API_ROOT + API.createValidateGraphic + '?id=',
      graphicId: '',
      isShowClause: false,
      text: "",
      photo:'',
      isGraphicError: false,
      isShowPopup: false
    }
  },
  mounted () {
    this.getGraphicId();
  },
  methods:{
    //上传图片
    addImage(){
      let self = this;
      let fd = new FormData(),
        xhr = new XMLHttpRequest(),
        input;
      input = document.createElement('input');
      input.setAttribute('id', 'myUploadInput');
      input.setAttribute('type', 'file');
      input.setAttribute('name', 'file');
      input.setAttribute('accept', 'image/jpeg,image/png'); //20230108_Anna 增加檔案格式限制
      document.body.appendChild(input);
      input.style.display = 'none';
      input.click();
      $('#myUploadInput').on('change', function () {
        if (!input.value) {
          return;
        }
        let type = input.value.split('.').pop();
        let imageSize = 5; //20230108_Anna 若要增大檔案改此處
        for (let i = 0, file; file = input.files[i++];) {
          if (imageSize && file.size > imageSize * 1024 * 1024  ) {
            alert('請上傳小於' + imageSize + 'M的檔案');
            return;
          }
        }
        for (let i = 0, file; file = input.files[i++];) {
          fd.append('file', file);
        }

        xhr.open('post', self.uploadFile);
        xhr.onreadystatechange = function () {
          if (xhr.status == 200) {
            if (xhr.readyState == 4) {
              let response = JSON.parse(xhr.responseText);
              if (response.code==200) {
                self.photo= response.data.pathUrlName;
              } else {
                self.isShowProgress = false;
              }
            }
          } else {
            //alert("上傳失敗！");
          }
        }
        self.isShowProgress = true;
        xhr.upload.onprogress = function (event) {
          let pre = Math.floor(100 * event.loaded / event.total);
          $('#progress-bar').css('width', pre + '%');
        }
        xhr.send(fd);
      });
      document.body.removeChild(input);
    },
    //提交表单数据
    submitForm(e){
      this.isSubmit = true;
      if (this.isAgree){
        if(!this.formData.gist || !this.formData.revert || !this.formData.name || !this.patternEmail(this.formData.mail) || (this.formData.phone && !this.patternPhone(this.formData.phone)) || (!this.formData.phone && this.formData.revert == '電話') || (!this.formData.mail) || !this.formData.shopName || !this.formData.content || !this.formData.verificationcode){
          return false;
        }
        this.formData.path = this.photo;
        this.$store.commit('showLoading');
        this.$post(API.postFeedback,{verificationcodeId: this.graphicId, ...this.formData})
        .then(res => {
          this.$store.commit('hideLoading');
          if (res.code === 200){
            this.isSubmit = false;
            this.isShowPopup = true;
            this.formData = {
                "gist": "",
                "revert": "",
                "name": "",
                "phone": "",
                "mail": "",
                "shopName": "",
                "content": "",
                "path": "",
                "verificationcode": ''
            }
            this.photo = '';
            this.isAgree = false;
            this.isGraphicError = false;
            this.getGraphicId();
          }else if(res.code === 502){
            this.isGraphicError = true;
            this.getGraphicId();
          }
        })
      }
      return;
    },
    getGraphicId(){
      this.graphicId = new Date().getTime() + '' + Math.random(1000);
    },
    openClausePopUp(){
      this.isShowClause = true;
    },
    closePopup(value){
      this.isShowClause = value;
    },
    patternEmail(email){
      return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(email);
    },
    patternPhone(phone){
      return /^[0-9]{5,20}$/.test(phone);
    }
  },
  components:{
    'clausePopup': ClausePopup,
    'my-file':File,
    'vue-select': VueSelect
  }
}
</script>
<style scoped lang="scss">
  .feedback{
    width:96%;
    height:auto;
    margin: 0 auto;
    box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
    background-color: #FFFFFF;
    border-radius: 20px;

    .feedback-conten{
      padding: 62px 122px 95px 129px;
      .tip{
         width:100%;
        p{
          display: inline-block;
        }
        .w-6{
          width: calc(67% - 5px);
          height: auto;
          padding-right: 110px;
          border-right: 1px solid #E1E1E1;
          color: #000000;
          font-size: 18px;
          line-height: 32px;
          letter-spacing: 1px;
        }
       .w-4{
         width:33%;
         vertical-align: top;
         padding-left:7%;
         text-align: right;
         span{
           display: block;
           color: #908782;
           font-size: 18px;
           line-height: 32px;
           letter-spacing: 1.13px;
           &.tel{
              font-size: 38px;
              color: #000;
             margin-bottom: 4px;
             letter-spacing: 0;
            }
         }
       }
      }
      .row{
        margin-top:50px;
        .col-md-6,.col-md-12{
          padding: 0 22px;
          font-size: 16px;
          div{
            width: calc(100% - 104px);
            display: inline-block;
            input,select,textarea{
              width: 100%;
              height: 48px;
              line-height: 48px;
              border: 1px solid #908782;
              border-radius: 24px;
              padding-left: 30px;
            }
            textarea{
              display: block;
              height: 225px;
              resize: none;
              outline: none;
            }
          }
          label{
            width: 100px;
            vertical-align: top;
            padding-top: 10px;
            position: relative;
            letter-spacing: 1px;
            em{
              color: red;
              position: absolute;
              left: -15px;
              top: 13px;
            }
          }
          .graphic{
            img{
              width: 76px;
              margin: 0 5px;
              vertical-align: middle;
            }
            input{
              width: calc(100% - 130px);
            }
            .reload-img{
              display: inline-block;
              width: 33px;
              height: 33px;
              background: url("../../assets/images/refer.svg") no-repeat center;
              background-size: 100% auto;
              vertical-align: middle;
              cursor: pointer;
            }
          }
          &.col-md-12{
            height: 225px;
            label{
              /*width: 10%;*/
            }
            div{

              /*width: 88%;*/
            }
          }
        }

      }
      .div-122{
        height: 122px;
        line-height: 122px;
        label{
          line-height: 1.2;
          vertical-align: middle !important;
        }
      }
      .div-123{
        padding-right: 10% !important;
      }
      .upload{
        position: relative;
        height: 122px;
        border: 1px solid #908782;
        border-radius: 15px;
        cursor: pointer;
        input[type='text']{
          border: 0 !important;
          display: none;
        }
        div{
          width:100%;
          text-align: center;
          position: relative;
            em{
              width: 60px;
              height: 60px;
              display: inline-block;
              background: url(../../assets/images/uploadIcon.svg) no-repeat left center;
              background-size: 100%;
              position: absolute;
              left: 26px;
              top: 30px;
            }
            span{
              width:240px;
              height: 22px;
              color: #A49D97;
              font-size: 15px;
              padding-left: 90px;
              line-height: 1.2;
               overflow:hidden;
              white-space:nowrap;
              text-overflow:ellipsis;
              display: inline-block;
            }
        }

      }
    }
  }
  .error{
    position: relative;
    .error-tip{
      margin-left:20px;
      margin-top: 4px;
      color: #D00717;
      font-size: 14px;
      font-weight: 500;
      position: absolute;
      line-height: 1;
    }
    input{
      border: 1px solid #D00717 !important;
    }
    &.graphic{
      .error-tip{
        margin-top: -24px;
      }
    }
  }
  .agree{
      text-align: center;
      margin-top: 102px;
      a{
        color: #908782;
        font-size: 16px;
        font-weight: 500;
        text-decoration: underline;
        cursor: pointer;
      }
      .error{
        width: 100%;
        text-align: center;
        .error-tip{
          width: 100%;
          margin: 0;
        }

      }
      .agree-box{
        position: relative;
         padding-left:10px;
          input[type=checkbox]{
            position: absolute;
            left: 0;
            box-sizing: border-box;
            height: 24px;
            width: 23px;
            border: 1px solid #979797;
            border-radius: 5px;
            background-color: #FFFFFF;
            cursor: pointer;
          }
          span{
            padding-left: 28px;
          }
      }

  }
  .agree-submit-btn{
    text-align: center;
    margin-top: 26px;
    button{
      height: 70px;
      width: 350px;
      line-height: 70px;
      background-color: #F5AC2D;
      border: 0;
      border-radius: 35px;
      cursor: pointer;
      color: #1F2329;
      font-size: 20px;
      font-weight: 500;
      outline: none;
      &:hover{
        background: #f7a61b;
      }
    }
  }
  @media (max-width:1080px){
    .feedback{
      width: calc(100% - 16px);
      margin: 0 auto;
      padding: 0 15px;
      .feedback-conten{
        padding: 30px 0 35px;
        .tip {
          .w-6{
            width: 100%;
            border: none;
            padding: 0;
            font-size: 15px;
            letter-spacing: 0.5px;
            line-height: 28px;
            margin-bottom: 30px;
          }
        }
        .row {
          margin: 0;
          .col-md-6{
            margin-bottom: 23px;
            &:nth-child(2n){
              padding-left:20px;
            }
          }
          .col-md-6, .col-md-12{
            padding: 0;
            div{
              width: calc(100% - 85px);
              select,input[type=text]{
                height: 45px;
                line-height: 43px;
                font-size: 14px;
              }
              &.upload{
                width: 100%;
              }
            }

            .graphic {
              vertical-align: top;
              input{
                width: calc(100%);
                margin-bottom: 20px;
              }
            }
            label{
              width: 80px;
              font-size: 15px;
              letter-spacing: 0.47px;
              line-height: 21px;
              margin-bottom: 15px;
            }
            &.textarea-box{
              width: 100%;
              label{
                width: 80px;
                padding: 0;
              }
              div{
                width: 100%;
              }
              textarea{
                height: 170px;
              }
            }
          }
          .div-122{
            height: auto;
            line-height: 43px;
            &.error{
              margin-top: 18px;
            }
          }
         .div-123{
           padding-right: 0 !important;
         }
        }
      }
    }
    .agree{
      margin-top: 30px;
    }
    .agree-submit-btn {
      margin-top: 14px;
      button{
        max-width: 220px;
        height: 45px;
        line-height: 43px;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 1.2px;
      }
    }
    .hot-line{
      padding-top: 26px;
      text-align: center;
      span{
        display: block;
      }
      .tel{
        font-size: 20px;
        letter-spacing: 0;
        line-height: 32px;
        a{
          color: #000000;
          &:hover{
            color: #000000;
          }
        }
      }
      .text{
        color: #908782;
        font-size: 14px;
        letter-spacing: 0.88px;
        line-height: 32px;
      }
    }
  }
  @media (max-width:767px){
    .feedback .feedback-conten .row .col-md-6{
      &:nth-child(2n){
        padding-left:0;
      }
    }
    .error.graphic .error-tip{
      margin-top:0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/default/Feedback.vue